export default __webpack_public_path__ + "static/media/dashboard-dark-background.5a419bc2.jpg";